import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, ListWrapper } from '../';
import { TariffPackageInstanceTableList } from './TariffPackageInstanceTableList';
import { IGetApiType } from '../../REST';
import { useProfile, useProfileIsRight, useTariffsFilterParams } from '../../hooks';
import { cleanTariffsStore, getTariffInstancesRelationSelect } from '../../middleware';

export const TariffPackageInstancesList: React.FC = observer(() => {
    const filterParams = useTariffsFilterParams();
    const idSpinners: IGetApiType[] = ['GET_TARIFF_PACKAGE_INSTANCE'];
    const { companyId = '' } = useProfile();
    const isLord = useProfileIsRight('LORD');

    return (
        <Catcher>
            <ListWrapper
                cleanStore={cleanTariffsStore}
                filterParams={filterParams}
                idSpinners={idSpinners}
                getRelationSelect={() => getTariffInstancesRelationSelect(isLord ? '' : companyId)}
            >
                <TariffPackageInstanceTableList />
            </ListWrapper>
        </Catcher>
    );
});
